/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IBeneficiaryUpdateMutationVariables = Types.Exact<{
  beneficiaryId: Types.Scalars['ID']['input'];
  beneficiaryParams: Types.IEscrowPartyParams;
}>;

export type IBeneficiaryUpdateMutation = {
  __typename?: 'Mutation';
  beneficiaryUpdate?: {
    __typename?: 'BeneficiaryUpdatePayload';
    success: boolean;
    errors?: Array<string> | null;
    beneficiary: {
      __typename?: 'Beneficiary';
      city?: string | null;
      companyName?: string | null;
      companyRegistrationNumber?: string | null;
      companyWebsite?: string | null;
      country?: string | null;
      id: string;
      postalCode?: string | null;
      region?: string | null;
      street?: string | null;
      streetNumber?: string | null;
    };
  } | null;
};

export const BeneficiaryUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'beneficiaryUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'beneficiaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'beneficiaryParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowPartyParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'beneficiaryUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'beneficiaryId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'beneficiaryId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'beneficiaryParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'beneficiaryParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beneficiary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyRegistrationNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IBeneficiaryUpdateMutation, IBeneficiaryUpdateMutationVariables>;
